export enum Colors {
  PRIMARY = '#08177A',
  NEUTRAL_STATE_PRIMARY = '#E5ECFB',
  NEUTRAL_STATE_SECONDARY = '#CCDAF7',
  SUCCESS_STATE_PRIMARY = '#E7F7ED',
  SUCCESS_STATE_SECONDARY = '#D0EFDB',
  ERROR_STATE_PRIMARY = '#FFEDEA',
  ERROR_STATE_SECONDARY = '#FFDDD7',
  BORDER_PRIMARY = '#F3F3F3',
}

export enum States {
  SUCCESS = 'success',
  NEUTRAL = 'neutral',
  ERROR = 'error',
}
